<template>
  <div id="conversation-wrapper">
    <div id="messages-wrapper" class="messages-wrapper" v-if="conversation">
      <div class="conversation-header">
        <round-button-with-icon icon="left-arrow-single" @click="back" />
        <message-sender-identifier :contact="contact" />
      </div>
      <div
        class="message"
        :id="'message-' + index"
        v-for="(message, index) in messages"
        :key="message.id"
      >
        <message :message="message" />
      </div>
    </div>
    <message-input @send-message="sendMessage" />
  </div>
</template>
<script>
import MessageInput from "./MessageInput.vue";
import Message from "./Message.vue";
import MessageSenderIdentifier from "./MessageSenderIdentifier.vue";
import RoundButtonWithIcon from "../../UI/RoundButtonWithIcon.vue";
export default {
  data() {
    return {};
  },
  computed: {
    messages() {
      if (this.conversation) {
        if (Object.keys(this.conversation.messages).length > 0) {
          return Object.values(this.conversation.messages);
        }
      }
      return [
        {
          body: "There are no messages on this thread.",
          senderKey: {
            userId: "system",
            tenantId: "system",
          },
        },
        {
          body: "Send a new message to start one!",
          senderKey: {
            userId: "system",
            tenantId: "system",
          },
        },
      ];
    },
    contact() {
      let nonUsers = this.conversation.participantKeys.filter((x) => {
        return x ? x.userId !== this.$store.state.user.userId : false;
      });
      if (nonUsers[0]) {
        return nonUsers[0];
      } else {
        return {
          given_name: "Deleted",
          family_name: "user",
        };
      }
    },
    contactFullName() {
      return `${this.contact.given_name} ${this.contact.family_name}`;
    },
  },
  methods: {
    displaySender(index, messages) {
      if (index !== 0) {
        return (
          messages[index - 1].senderKey.userId !==
          messages[index].senderKey.userId
        );
      } else {
        return true;
      }
    },
    sendMessage(body) {
      this.$emit("send-message", body);
    },
    back() {
      this.$emit("back");
    },
  },
  created() {
    setTimeout(() => {
      let element = document.getElementById(
        "message-" + (this.messages.length - 1)
      );
      element.scrollIntoView();
    }, 300);
  },

  components: {
    MessageInput,
    Message,
    MessageSenderIdentifier,
    RoundButtonWithIcon,
  },
  props: ["conversation"],
  emits: ["send-message", "back"],
};
</script>
<style scoped>
#conversation-wrapper {
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.conversation-header {
  width: 100%;
  top: 0;
  z-index: 2;
  position: sticky;
  display: flex;
  align-items: center;
  background-color: var(--backgroundColor);
}

#messages-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  scroll-behavior: smooth;
}

.message:nth-child(2) {
  margin-top: auto;
}
</style>
